/**
 * @generated SignedSource<<28b583e1b86fd8b4b35590372d7c2a62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerAppId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "customerAppId",
    "variableName": "customerAppId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAppId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAccountId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentAppId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appStatus",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSkuPrice",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appMarkupAbsolute",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appMarkupPercentage",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wholesaleDiscountPercentage",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentOrder",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bcId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedEmail",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useEmail",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domain",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pwd",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shareCredentials",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSubscription",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passThroughFees",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soEntered",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initiatedBy",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forwardEmail",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSku",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appUrl",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appLogo",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appType",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signupUrl",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showDomain",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showUsername",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vppId",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programName",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stage",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extBcId",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bcStatus",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usingAccountId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactEmail",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFirstName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactLastName",
  "storageKey": null
},
v49 = [
  (v38/*: any*/)
],
v50 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "psStatus": 0
      }
    }
  ],
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":0})"
},
v51 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "psStatus": 4
    }
  }
],
v52 = {
  "alias": "held4Using",
  "args": (v51/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":4})"
},
v53 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "psStatus": 5
    }
  }
],
v54 = {
  "alias": "held5Using",
  "args": (v53/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":5})"
},
v55 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "psStatus": 6
    }
  }
],
v56 = {
  "alias": "held6Using",
  "args": (v55/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":6})"
},
v57 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "psStatus": 7
    }
  }
],
v58 = {
  "alias": "held7Using",
  "args": (v57/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":7})"
},
v59 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "psStatus": 8
    }
  }
],
v60 = {
  "alias": "held8Using",
  "args": (v59/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":8})"
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "UserTsConnection",
  "kind": "LinkedField",
  "name": "userTsByAccountId",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserT",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v24/*: any*/),
        (v25/*: any*/),
        (v61/*: any*/),
        (v62/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provisioningAccountId",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountStatus",
  "storageKey": null
},
v66 = {
  "alias": "held4Provisioning",
  "args": (v51/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":4})"
},
v67 = {
  "alias": "held5Provisioning",
  "args": (v53/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":5})"
},
v68 = {
  "alias": "held6Provisioning",
  "args": (v55/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":6})"
},
v69 = {
  "alias": "held7Provisioning",
  "args": (v57/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":7})"
},
v70 = {
  "alias": "held8Provisioning",
  "args": (v59/*: any*/),
  "concreteType": "PaymentSourceTsConnection",
  "kind": "LinkedField",
  "name": "paymentSourceTsByAccountId",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "paymentSourceTsByAccountId(condition:{\"psStatus\":8})"
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address1",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address2",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountType",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useBudgets",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestBudgetApproved",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preApproveSubs",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flowTaskId",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskType",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskData",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flowStepId",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stepState",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "UserTsConnection",
  "kind": "LinkedField",
  "name": "userTsByAccountId",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserT",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v24/*: any*/),
        (v25/*: any*/),
        (v61/*: any*/),
        (v62/*: any*/),
        (v86/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionManageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerAppT",
        "kind": "LinkedField",
        "name": "customerAppTByCustomerAppId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAppEmailTsConnection",
            "kind": "LinkedField",
            "name": "customerAppEmailTsByCustomerAppId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAppEmailT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserT",
                    "kind": "LinkedField",
                    "name": "userTByUserId",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v27/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AppT",
            "kind": "LinkedField",
            "name": "appTByAppId",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AppT",
                "kind": "LinkedField",
                "name": "appTByOemAppId",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountT",
                    "kind": "LinkedField",
                    "name": "accountTByAccountId",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VppTsConnection",
                        "kind": "LinkedField",
                        "name": "vppTsByVendorId",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VppT",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VppRtsConnection",
                                "kind": "LinkedField",
                                "name": "vppRTsByVppId",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "VppRT",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v42/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BindCardT",
            "kind": "LinkedField",
            "name": "bindCardTByBcId",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountT",
                "kind": "LinkedField",
                "name": "accountTByUsingAccountId",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v50/*: any*/),
                  (v52/*: any*/),
                  (v54/*: any*/),
                  (v56/*: any*/),
                  (v58/*: any*/),
                  (v60/*: any*/),
                  (v63/*: any*/)
                ],
                "storageKey": null
              },
              (v64/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountT",
                "kind": "LinkedField",
                "name": "accountTByProvisioningAccountId",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v65/*: any*/),
                  (v50/*: any*/),
                  (v66/*: any*/),
                  (v67/*: any*/),
                  (v68/*: any*/),
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v63/*: any*/)
                ],
                "storageKey": null
              },
              (v61/*: any*/),
              (v62/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByCustomerAccountId",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v26/*: any*/),
              (v77/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FlowTaskTsConnection",
            "kind": "LinkedField",
            "name": "flowTaskTsByCustomerAppId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FlowTaskT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlowStepTsConnection",
                    "kind": "LinkedField",
                    "name": "flowStepTsByFlowTaskId",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowStepT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v84/*: any*/),
                          (v85/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionManageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerAppT",
        "kind": "LinkedField",
        "name": "customerAppTByCustomerAppId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAppEmailTsConnection",
            "kind": "LinkedField",
            "name": "customerAppEmailTsByCustomerAppId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAppEmailT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserT",
                    "kind": "LinkedField",
                    "name": "userTByUserId",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v86/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v86/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AppT",
            "kind": "LinkedField",
            "name": "appTByAppId",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AppT",
                "kind": "LinkedField",
                "name": "appTByOemAppId",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountT",
                    "kind": "LinkedField",
                    "name": "accountTByAccountId",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VppTsConnection",
                        "kind": "LinkedField",
                        "name": "vppTsByVendorId",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VppT",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v39/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VppRtsConnection",
                                "kind": "LinkedField",
                                "name": "vppRTsByVppId",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "VppRT",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v42/*: any*/),
                                      (v86/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v86/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v86/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v86/*: any*/)
                ],
                "storageKey": null
              },
              (v86/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BindCardT",
            "kind": "LinkedField",
            "name": "bindCardTByBcId",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountT",
                "kind": "LinkedField",
                "name": "accountTByUsingAccountId",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v50/*: any*/),
                  (v52/*: any*/),
                  (v54/*: any*/),
                  (v56/*: any*/),
                  (v58/*: any*/),
                  (v60/*: any*/),
                  (v87/*: any*/),
                  (v86/*: any*/)
                ],
                "storageKey": null
              },
              (v64/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountT",
                "kind": "LinkedField",
                "name": "accountTByProvisioningAccountId",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v65/*: any*/),
                  (v50/*: any*/),
                  (v66/*: any*/),
                  (v67/*: any*/),
                  (v68/*: any*/),
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v87/*: any*/),
                  (v86/*: any*/)
                ],
                "storageKey": null
              },
              (v61/*: any*/),
              (v62/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v86/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByCustomerAccountId",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v26/*: any*/),
              (v77/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v86/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FlowTaskTsConnection",
            "kind": "LinkedField",
            "name": "flowTaskTsByCustomerAppId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FlowTaskT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlowStepTsConnection",
                    "kind": "LinkedField",
                    "name": "flowStepTsByFlowTaskId",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowStepT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v86/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v86/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "410e68d5594ee1ab9503700cbfadd3bf",
    "id": null,
    "metadata": {},
    "name": "SubscriptionManageQuery",
    "operationKind": "query",
    "text": "query SubscriptionManageQuery(\n  $customerAppId: UUID!\n) {\n  customerAppTByCustomerAppId(customerAppId: $customerAppId) {\n    customerAppId\n    appId\n    customerAccountId\n    parentAppId\n    appStatus\n    appSkuPrice\n    appMarkupAbsolute\n    appMarkupPercentage\n    wholesaleDiscountPercentage\n    notes\n    paymentOrder\n    bcId\n    sharedEmail\n    useEmail\n    domain\n    username\n    pwd\n    shareCredentials\n    showSubscription\n    passThroughFees\n    soEntered\n    initiatedBy\n    customerAppEmailTsByCustomerAppId {\n      nodes {\n        userId\n        userTByUserId {\n          email\n          nodeId\n        }\n        accountId\n        forwardEmail\n        nodeId\n      }\n    }\n    appTByAppId {\n      appName\n      appSku\n      appUrl\n      appLogo\n      appType\n      description\n      signupUrl\n      showDomain\n      showUsername\n      appTByOemAppId {\n        appId\n        accountTByAccountId {\n          accountName\n          vppTsByVendorId {\n            totalCount\n            nodes {\n              vppId\n              programName\n              ctaText\n              vppRTsByVppId {\n                totalCount\n                nodes {\n                  stage\n                  nodeId\n                }\n              }\n              nodeId\n            }\n          }\n          nodeId\n        }\n        nodeId\n      }\n      nodeId\n    }\n    bindCardTByBcId {\n      bcId\n      extBcId\n      bcStatus\n      usingAccountId\n      accountTByUsingAccountId {\n        contactEmail\n        contactFirstName\n        contactLastName\n        paymentSourceTsByAccountId(condition: {psStatus: 0}) {\n          totalCount\n        }\n        held4Using: paymentSourceTsByAccountId(condition: {psStatus: 4}) {\n          totalCount\n        }\n        held5Using: paymentSourceTsByAccountId(condition: {psStatus: 5}) {\n          totalCount\n        }\n        held6Using: paymentSourceTsByAccountId(condition: {psStatus: 6}) {\n          totalCount\n        }\n        held7Using: paymentSourceTsByAccountId(condition: {psStatus: 7}) {\n          totalCount\n        }\n        held8Using: paymentSourceTsByAccountId(condition: {psStatus: 8}) {\n          totalCount\n        }\n        userTsByAccountId {\n          nodes {\n            userId\n            email\n            firstName\n            lastName\n            nodeId\n          }\n        }\n        nodeId\n      }\n      provisioningAccountId\n      accountTByProvisioningAccountId {\n        contactEmail\n        contactFirstName\n        contactLastName\n        accountStatus\n        paymentSourceTsByAccountId(condition: {psStatus: 0}) {\n          totalCount\n        }\n        held4Provisioning: paymentSourceTsByAccountId(condition: {psStatus: 4}) {\n          totalCount\n        }\n        held5Provisioning: paymentSourceTsByAccountId(condition: {psStatus: 5}) {\n          totalCount\n        }\n        held6Provisioning: paymentSourceTsByAccountId(condition: {psStatus: 6}) {\n          totalCount\n        }\n        held7Provisioning: paymentSourceTsByAccountId(condition: {psStatus: 7}) {\n          totalCount\n        }\n        held8Provisioning: paymentSourceTsByAccountId(condition: {psStatus: 8}) {\n          totalCount\n        }\n        userTsByAccountId {\n          nodes {\n            userId\n            email\n            firstName\n            lastName\n            nodeId\n          }\n        }\n        nodeId\n      }\n      firstName\n      lastName\n      address1\n      address2\n      city\n      state\n      postalCode\n      country\n      nodeId\n    }\n    accountTByCustomerAccountId {\n      accountName\n      accountId\n      accountType\n      contactEmail\n      contactFirstName\n      contactLastName\n      useBudgets\n      latestBudgetApproved\n      preApproveSubs\n      nodeId\n    }\n    flowTaskTsByCustomerAppId {\n      nodes {\n        flowTaskId\n        taskType\n        taskData\n        flowStepTsByFlowTaskId {\n          nodes {\n            flowStepId\n            stepState\n            nodeId\n          }\n        }\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "26423ee15c58a72a3672621b1e3744b6";

module.exports = node;
